import { Component, OnInit, inject } from '@angular/core';
import { DashboardService } from '../../dashboard.service';
import { saveAs } from '@progress/kendo-file-saver';
import { DateTime } from 'luxon';
import { catchError } from 'rxjs/operators';
import { Platform } from '@angular/cdk/platform';
import { EnvironmentService } from '../../../services/environment.service';
import { NgxLoadingModule } from 'ngx-loading';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-activeppfa',
  templateUrl: './activeppfa.component.html',
  styleUrls: ['./activeppfa.component.scss'],
  imports: [
    NgxLoadingModule,
    MatCardModule,
    MatIconModule,
    MatButtonModule,
    MatSelectModule,
    MatInputModule,
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
  ],
  providers: [],
})
export class ActivePPfaComponent implements OnInit {
  private dbs = inject(DashboardService);
  private pltfrm = inject(Platform);
  private envSvc = inject(EnvironmentService);

  private environment;
  public expiring: Array<object>;
  public updating: Array<object>;
  public data: object;
  state = 'start';
  public startDate: string;
  public endDate: string;
  private baseUrl = 'https://dev.rightbridge.net/api/BaseV2/api/v3';

  GetClass(startDate: string, expireDate: string): string {
    const start = DateTime.fromJSDate(new Date(startDate)).toUTC();
    const expire = DateTime.fromJSDate(new Date(expireDate)).toUTC();
    if (
      expire >= DateTime.now().minus({ days: 1 }).toUTC() &&
      expire <= DateTime.now().add({ days: 1 }).toUTC()
    ) {
      return 'ExpiringTomorrow';
    }
    if (
      expire >= DateTime.now().minus({ days: 1 }).toUTC() &&
      expire <= DateTime.now().add(7, 'days').toUTC()
    ) {
      return 'ExpiringSoon';
    }
    if (
      start >= DateTime.now().toUTC() &&
      start <= DateTime.now().add({ days: 1 }).toUTC()
    ) {
      return 'EffectiveToday';
    }
    if (
      start >= DateTime.now().toUTC() &&
      start <= DateTime.now().add({ days: 7 }).toUTC()
    ) {
      return 'EffectiveSoon';
    }
    return '';
  }

  updateRowCount(value: number): void {
    this.state = 'loaded';
    if (this.data['expiring']['data'].length) {
      this.expiring = this.data['expiring']['data'].slice(0, value);
    }
    if (this.data['updating']['data'].length) {
      this.updating = this.data['updating']['data'].slice(0, value);
    }
    if (this.expiring === null && this.updating === null) {
      this.state = 'none';
    }
  }

  download(): void {
    const iosSafari =
      this.pltfrm.IOS ||
      (navigator?.['userAgentData']?.platform === 'macOS' &&
        navigator.maxTouchPoints > 1);

    this.dbs
      .getDashboardAnnuitiesCsv('ppfaupdates', this.startDate, this.endDate)
      .subscribe(data => {
        const filename = `active_ppfas_and_connectors.csv`;

        let fileData;
        const reader = new FileReader();
        reader.readAsDataURL(data);
        reader.onloadend = () => {
          fileData = reader.result;
          saveAs(fileData, filename, {
            proxyURL: `${this.baseUrl}/util/proxy`,
            proxyTarget: '_self',
            forceProxy: iosSafari,
          });
        };
      });
  }

  setDate(ev) {
    this.startDate = new Date(ev.value).toISOString();
  }
  ngOnInit(): void {
    this.environment = this.envSvc.get();
    this.baseUrl = this.environment.apiBase;
  }

  load(): void {
    this.state = 'loading';
    this.dbs.getDashboardAnnuities('ppfaupdates').subscribe({
      next: x => {
        this.state = 'loaded';
        this.data = x;
        if (x['expiring']['data'].length) {
          this.expiring = x['expiring']['data'].slice(0, 10);
        }
        if (x['updating']['data'].length) {
          this.updating = x['updating']['data'].slice(0, 10);
        }
        if (this.expiring === null && this.updating === null) {
          this.state = 'none';
        }
      },
      error: e => {
        this.state = 'none';
        catchError(e);
      },
    });
  }
}
